import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import OfferTicker from "@/components/OfferTicker";
import SalesPopup from "@/components/SalesPopup";
import NewsletterPopup from "@/components/NewsletterPopup";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import WomenComingSoon from "@/pages/WomenComingSoon";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Profile from "@/pages/Profile";
import OrderTracking from "@/pages/OrderTracking";

import Atelier from "@/pages/Atelier";
import Sustainability from "@/pages/Sustainability";
import Stories from "@/pages/Stories";
import Shipping from "@/pages/Shipping";
import Returns from "@/pages/Returns";
import SizeGuide from "@/pages/SizeGuide";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
function App() {
  useEffect(() => {
    document.title = "INDUS EIRENE — A Quiet Luxury House";
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <WishlistProvider>
          <CartProvider>
            <BrowserRouter>
              <ScrollToTop />
              <div className="min-h-screen flex flex-col bg-background text-foreground">
                <OfferTicker />
                <Navbar />
                {/* <main className="flex-1" data-testid="main-content"> */}
                <main className="flex-1 min-h-0" data-testid="main-content">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/shop" element={<Products />} />
                    <Route path="/shop/women" element={<WomenComingSoon />} />
                    <Route path="/shop/women/:type" element={<WomenComingSoon />} />
                    <Route path="/shop/:gender" element={<Products />} />
                    <Route path="/shop/:gender/:type" element={<Products />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/track" element={<OrderTracking />} />
                    <Route path="/track" element={<OrderTracking />} />

                    <Route path="/atelier" element={<Atelier />} />
                    <Route path="/sustainability" element={<Sustainability />} />
                    <Route path="/stories" element={<Stories />} />

                    <Route path="/shipping" element={<Shipping />} />
                    <Route path="/returns" element={<Returns />} />
                    <Route path="/size-guide" element={<SizeGuide />} />
                    <Route path="/contact" element={<Contact />} />

                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/checkout" element={
                      <ProtectedRoute><Checkout /></ProtectedRoute>
                    } />
                    <Route path="/profile" element={
                      <ProtectedRoute><Profile /></ProtectedRoute>
                    } />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
                <SalesPopup />
                <NewsletterPopup />
                <Toaster
                  position="top-center"
                  theme="system"
                  toastOptions={{
                    style: {
                      background: "hsl(var(--surface))",
                      color: "hsl(var(--foreground))",
                      border: "1px solid hsl(var(--border))",
                      borderRadius: 0,
                      fontFamily: "Outfit, sans-serif",
                    },
                  }}
                />
              </div>
            </BrowserRouter>
          </CartProvider>
        </WishlistProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
